import { defineComponent as n, ref as m, openBlock as c, createBlock as f, unref as p, mergeProps as y } from "vue";
import b from "./ghl-ui.es312.js";
import o from "./ghl-ui.es313.js";
const g = n({
  name: "UIDynamicTags",
  inheritAttrs: !1,
  components: { NDynamicTags: o }
}), v = n({
  ...g,
  props: {
    id: {
      required: !0,
      type: String
    },
    defaultValue: {
      type: Array,
      default: null
    },
    type: {
      type: String,
      default: "default"
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    max: {
      type: Number,
      default: 10
    },
    closable: {
      type: Boolean,
      default: !0
    },
    round: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["onUpdate"],
  setup(e, { emit: u }) {
    const d = e, r = u, t = m(d.defaultValue ?? []), s = (a) => {
      t.value = b(
        a,
        (l, i) => l.trim() === i.trim()
      ), r("onUpdate", t.value);
    };
    return (a, l) => (c(), f(p(o), y({
      value: t.value,
      type: e.type,
      disabled: e.disabled,
      max: e.max,
      closable: e.closable,
      round: e.round,
      class: [`hl-${e.type}`]
    }, a.$attrs, { "onUpdate:value": s }), null, 16, ["value", "type", "disabled", "max", "closable", "round", "class"]));
  }
}), B = v;
export {
  B as default
};
